export class ListMicrosoft365SharePointSitesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "search",
            "baseName": "search",
            "type": "string",
            "format": ""
        },
        {
            "name": "ids",
            "baseName": "ids",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMicrosoft365SharePointSitesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
